import { isWeb } from "@helpers/platform";
import { useAppTheme } from "@hooks/useAppTheme";
import { formatCount } from "@memorang/helpers/src/common";
import Box from "@memorang/ui/src/components/Box";
import CustomBottomSheetTextInput from "components/CustomBottomSheetTextInput";
import { useTranslation } from "react-i18next";
import { Text, TextInput } from "react-native-paper";

const MAX_LENGTH = 6000;

type Props = {
	value?: string;
	onChangeText: (value: string) => void;
	disabled?: boolean;
};

const Writing = ({ value, onChangeText, disabled }: Props) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	const wordCount = value?.trim().split(/\s+/).filter(Boolean).length ?? 0;
	const placeholder = t("writing.placeholder");

	if (isWeb) {
		return (
			<Box gap={4}>
				<TextInput
					placeholder={placeholder}
					disabled={disabled}
					onChangeText={onChangeText}
					contentStyle={{
						minWidth: 300,
						minHeight: 150,
					}}
					placeholderTextColor={theme.colors.onSurfaceDisabled}
					multiline
					mode="outlined"
					value={value}
					autoComplete="off"
					autoCorrect={false}
					spellCheck={false}
					autoCapitalize="none"
					maxLength={MAX_LENGTH}
				/>
				<Text variant="bodySmall">
					{t("writing.wordCount", {
						count: wordCount,
						word: formatCount(t("common.word"), wordCount),
					})}
				</Text>
			</Box>
		);
	}

	return (
		<CustomBottomSheetTextInput
			value={value}
			onChangeText={onChangeText}
			placeholder={placeholder}
			wordCount={wordCount}
			maxLength={MAX_LENGTH}
			disabled={disabled}
		/>
	);
};

export default Writing;
